import React from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import {
  Spinner,
  Modal,
} from "reactstrap";

export default function Loading({
  loadingControl = {
    open: false,
    message: '',
  },
}) {
  if (!loadingControl.open) { return null }
  return (
    <Modal isOpen={loadingControl.open} style={{ backgroundColor: 'white', borderRadius: '10px' }}>
      <div style={{
        padding: '10px',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor: 'white',
        borderRadius: '10px'
      }}>
        <div style={{ paddingRight: '10px' }}>
          <Spinner
            style={{ color: "gray" }}
            animation="border"
            size="lg"
          />
        </div>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <p>{loadingControl.message}</p>
        </div>
      </div>
    </Modal>
  )
}
